import { PackagePermission } from 'shared/models/user';

export const SANDBOX_STORAGE_KEY = 'devsite:sandboxPermissions';

export interface SandboxPermission {
  permission: PackagePermission;
  enabled: boolean;
}
